module.exports = __webpack_public_path__ + "img/pop-up-map.a8be49b1.png";